/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 査定比較ステータス
 */
export type AssessmentsComparisonStatus =
  (typeof AssessmentsComparisonStatus)[keyof typeof AssessmentsComparisonStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssessmentsComparisonStatus = {
  idle: 'idle',
  generating: 'generating',
  completed: 'completed',
  failed: 'failed',
  deleted: 'deleted',
} as const;
